/**
 * Isolate the context in an IIFE
 *
 * @param object $ jQuery object
 * @param object Drupal Drupal object
 * @param window window Current window object
 */

(function ($, Drupal, window) {
  /**
   * Main script for the current theme
   */
  Drupal.behaviors.themeJS = {
    attach (context) {
      // Show and hide header on scrolling.
      const SCROLL_THRESHOLD = 200;
      const CLASS_SCROLLED = 'js-did-scroll';

      const $window = $(window);
      const $body = $('body', context);

      $window.scroll(() => {
        const offsetTop = $window.scrollTop();
        const didPassThreshold = offsetTop > SCROLL_THRESHOLD;

        if (didPassThreshold && !$body.hasClass(CLASS_SCROLLED)) {
          $body.addClass(CLASS_SCROLLED);
        } else if (!didPassThreshold && $body.hasClass(CLASS_SCROLLED)) {
          $body.removeClass(CLASS_SCROLLED);
        }
      });

      const CLASS_TOGGLER = 'js-menu-opened';
      $('.navbar-toggler', context).click(() => {
        $body.toggleClass(CLASS_TOGGLER);
      });

      // Auto submit Blog filter form.
      const $blogFilterForm = $('form.emory-blog-filter', context);
      $('select', $blogFilterForm).change(function () {
        $blogFilterForm.submit();
      });
    },
  };
}(jQuery, Drupal, window));
